@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.googlemaps

import com.narbase.letsgo.router.EndPoint

object ResolveShortLinkEndpoint : EndPoint<ResolveShortLinkEndpoint.Request, ResolveShortLinkEndpoint.Response>() {
    class Request(
        val shortLink: String
    )

    class Response(
        val url: String?,
        val lat: Double? = null,
        val lng: Double? = null,
        val address: String? = null
    )
}